import { TextingMessage } from "generated/openApi";
import { createContext, ReactNode, useCallback, useContext, useState } from "react";

interface TextingMessageContextValue {
  latestMessage: TextingMessage | null;
  updateLatestMessage: (message: TextingMessage) => void;
}

// Create context with explicit type and initial value
const TextingMessageContext = createContext<TextingMessageContextValue>({
  latestMessage: null,
  updateLatestMessage: () => {
    console.warn("No provider found for TextingMessageContext");
  },
});

// Context Provider Component
export const TextingMessageProvider = ({ children }: { children: ReactNode }) => {
  const [latestMessage, setLatestMessage] = useState<TextingMessage | null>(null);

  const updateLatestMessage = useCallback((message: TextingMessage) => {

    setLatestMessage(message);
  }, []);

  return (
    <TextingMessageContext.Provider value={{ latestMessage, updateLatestMessage }}>
      {children}
    </TextingMessageContext.Provider>
  );
};

// Custom hook for consuming context
export const useTextingMessage = () => {
  return useContext(TextingMessageContext);
};
